import { loadComponent } from '@/helpers/asyncLoaders'
import store from '@/store/store'

import {
  VUEX_USER_HAS_CONFERENCE_ASIAN,
  VUEX_USER_HAS_CONFERENCE_DOMESTIC,
  VUEX_USER_HAS_CONFERENCE_INTERNATIONAL
} from '@/store/constants/user'

const hasPerms = () => {
  return store.getters[VUEX_USER_HAS_CONFERENCE_ASIAN] ||
    store.getters[VUEX_USER_HAS_CONFERENCE_DOMESTIC] ||
    store.getters[VUEX_USER_HAS_CONFERENCE_INTERNATIONAL]
}

export const routes = {
  path: 'fall27',
  name: 'fall27--main',
  meta: {
    conferenceClass: 'fall27'
  },
  component: loadComponent('GlobalConference/Fall27/Main.vue'),
  redirect: { name: 'fall27--landing' },
  children: [
    {
      path: 'load',
      name: 'fall27--load',
      component: loadComponent('GlobalConference/Fall27/Pages/Load.vue')
    },
    {
      path: 'landing',
      name: 'fall27--landing',
      component: loadComponent('GlobalConference/Fall27/Pages/LandingNew.vue'),
      beforeEnter: (to, from, next) => {
        if (!store.state.globalConference.fall27.loaded) {
          return next({ name: 'fall27--load' })
        }
        next()
      }
    },
    {
      path: 'categories',
      name: 'fall27--categories',
      component: loadComponent('GlobalConference/Fall27/Pages/Categories.vue'),
      meta: {
        eventCategory: 'fall27',
        title: 'Product Categories',
        navigation: [
          'Womens',
          'Mens',
          'Kids',
          'Unisex'
        ]
      }
    },
    {
      path: 'ads',
      name: 'fall27--ads',
      component: loadComponent('GlobalConference/Fall27/Pages/AdvertisingNew.vue'),
      beforeEnter: (to, from, next) => {
        if (hasPerms()) {
          next()
        } else {
          next('/')
        }
      },
      meta: {
        eventCategory: 'fall27',
        title: 'Advertising',
        navigation: [
          'Marketing',
          'Womens',
          'Mens',
          'Kids',
          'Unisex',
          'Work',
          'BTS',
          'International',
          'Performance',
          'Social',
          'Radio',
          'Apparel'
        ]
      }
    },
    {
      path: 'sessions',
      name: 'fall27--sessions',
      component: loadComponent('GlobalConference/Fall27/Pages/SessionsNew.vue'),
      beforeEnter: (to, from, next) => {
        if (hasPerms()) {
          next()
        } else {
          next('/')
        }
      },
      meta: {
        eventCategory: 'fall27',
        title: 'General Sessions'
      }
    },
    {
      path: '',
      name: 'fall27--dashboard',
      redirect: { name: 'fall27--ads' }
    }
  ]
}
